export const FtlColumns = [
    {
        name: 'Номер заказа',
        key: 'id',
    },
    {
        name: 'Тип ФТЛ',
        key: 'ftl_type_name',
    },
    {
        name: 'Номер накл. заказчика',
        key: 'dop_order_number',
        withHint: true,
    },
    {
        name: 'Компания',
        key: 'company_name',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'Направление',
        key: 'direction',
    },
    {
        name: 'Дата создания',
        key: 'created_at',
    },
    {
        name: 'Дата и Время забора',
        key: 'take_at',
    },
    {
        name: 'Дата в пути',
        key: 'status_on_tne_way',
    },
    {
        name: 'Дата доставки',
        key: 'delivered_at',
    },
    {
        name: 'Авто',
        key: 'car',
    },
    {
        name: 'Себестоимость',
        key: 'cost',
    },
    {
        name: 'Выставление',
        key: 'paid_price',
    },
    {
        name: 'Номер АВР',
        key: 'act_number',
    },
    {
        name: 'Менеджер',
        key: 'manager',
    },
    {
        name: 'Ответственный логист',
        key: 'logist',
    },
]

export const FTLStatusColors = {
    logist_bid_signed: 'yellow',
    processing_logist_bid: 'yellow',
    created: 'blue--outline',
    wait_cost_price: 'yellow',
    on_updating: 'yellow',
    on_approval: 'yellow',
    carrier_data_entered: 'yellow',
    on_the_way: 'yellow--outline',
    approved: 'yellow',
    on_inspection_head_transport: 'yellow',
    completed: 'green--outline',
    confirmed: 'green',
    delivered: 'green--fill',
    denied: 'red',
    canceled: 'red--outline',
    exported_declaration: 'yellow--fill',
    crossed_the_border: 'orange--outline',
}

export const FtlFileNames = {
    stamp: 'Фото пломбы',
    invoice: 'Инвойс',
    packing_list: 'Пакинг лист',
    certificate_of_origin: 'Сертификат происхождения',
    certificate_of_safety: 'Сертификат безопасности',
    declaration: 'Скан копия ЭК',
    border_post_seal: 'Фото печати пограничного поста',
    removed_stamp: 'Фото снятой пломбы',
    carcass: 'Фото открытого кузова',
}
